
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/welcome/spaces",
      function () {
        return require("private-next-pages/welcome/spaces.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/welcome/spaces"])
      });
    }
  